export default __webpack_public_path__ + "static/all_bunker_locations-bac30eac5386cdb8343c06e412e0c6bd.png";